'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.parseSpacingProp = parseSpacingProp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _shallowEqual = require('../../utils/shallowEqual');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  'right-x-large': 'ccl-d13ab933a3eb0ced',
  'left-x-large': 'ccl-afce6c922143902f',
  'top-x-large': 'ccl-24ccff7c5af3071f',
  'bottom-x-large': 'ccl-9692c7abaea8c56e',
  'horizontal-x-large': 'ccl-ba043e199ab7a13d',
  'vertical-x-large': 'ccl-ac8790cb4c182791',
  'all-x-large': 'ccl-36fa58f43e68b879',
  'adjacent-horizontal-x-large': 'ccl-233596db5f4b7da5',
  'adjacent-vertical-x-large': 'ccl-15a431c3835399f3',
  'right-large': 'ccl-d8cd83ee8bfa836a',
  'left-large': 'ccl-767f8979b32c7bb9',
  'top-large': 'ccl-4912656e9f5496e5',
  'bottom-large': 'ccl-0338edd3d4c3a41b',
  'horizontal-large': 'ccl-a48a11346c8e59e5',
  'vertical-large': 'ccl-da88f08384cd666d',
  'all-large': 'ccl-1993f7fbfa5c2647',
  'adjacent-horizontal-large': 'ccl-5fe41faebfb1f73f',
  'adjacent-vertical-large': 'ccl-2913207c6cd67950',
  'right-medium': 'ccl-a0603812a874844f',
  'left-medium': 'ccl-24c197eb36c1c3d3',
  'top-medium': 'ccl-c9da0519c26dc749',
  'bottom-medium': 'ccl-4be034de38ffc86c',
  'horizontal-medium': 'ccl-3b8f814bd5a1573c',
  'vertical-medium': 'ccl-d9067e2b2b75c64a',
  'all-medium': 'ccl-85b2395f51210087',
  'adjacent-horizontal-medium': 'ccl-7dd644af63dc5b67',
  'adjacent-vertical-medium': 'ccl-b176b26fc7009752',
  'right-small': 'ccl-d52c0dc87c03d8a1',
  'left-small': 'ccl-b84e895e9b743aba',
  'top-small': 'ccl-9aab795066526b4d',
  'bottom-small': 'ccl-b79f709a3ebf5895',
  'horizontal-small': 'ccl-ce9fb37d95f6ee20',
  'vertical-small': 'ccl-f7d830a9c75473b8',
  'all-small': 'ccl-2b95b58eee016846',
  'adjacent-horizontal-small': 'ccl-dccb3f5f8e8213ec',
  'adjacent-vertical-small': 'ccl-91a59d84c8a54641',
  'right-x-small': 'ccl-a6fe14df36a14ee6',
  'left-x-small': 'ccl-b308a2db3758e3e5',
  'top-x-small': 'ccl-c8eb8fd8fb351d32',
  'bottom-x-small': 'ccl-2b20d39653ab41b2',
  'horizontal-x-small': 'ccl-cbc2267cd63339bf',
  'vertical-x-small': 'ccl-569b5e40f810583b',
  'all-x-small': 'ccl-84de633f8a9ceaad',
  'adjacent-horizontal-x-small': 'ccl-6a536dee6972c57c',
  'adjacent-vertical-x-small': 'ccl-6b45f37d4cb665b6',
  'right-zero': 'ccl-fd575e0089b9acdf',
  'left-zero': 'ccl-10ea04cdcbb46587',
  'top-zero': 'ccl-3eea09964309de47',
  'bottom-zero': 'ccl-34c9caac7a97590d',
  'horizontal-zero': 'ccl-41368937e0bd47d1',
  'vertical-zero': 'ccl-b460e035c72a5b58',
  'all-zero': 'ccl-6a4193caaa1446fa',
  'adjacent-horizontal-zero': 'ccl-bffa40e09b1e32ef',
  'adjacent-vertical-zero': 'ccl-61d977f65cdaa96c',
  'tablet-right-x-large': 'ccl-04ecfb8ff44aa8a6',
  'tablet-left-x-large': 'ccl-23344ef88b367839',
  'tablet-top-x-large': 'ccl-8d637d23d7754f6a',
  'tablet-bottom-x-large': 'ccl-61059584b9d0f874',
  'tablet-horizontal-x-large': 'ccl-7c622ed17ae981dd',
  'tablet-vertical-x-large': 'ccl-903e36b5461f916d',
  'tablet-all-x-large': 'ccl-fa61f7d4c4850f64',
  'tablet-adjacent-horizontal-x-large': 'ccl-8d50ab84b3e3189b',
  'tablet-adjacent-vertical-x-large': 'ccl-d8f9fe06a19d8e33',
  'tablet-right-large': 'ccl-bb3204a6cb0520b7',
  'tablet-left-large': 'ccl-68c139ca4575ecac',
  'tablet-top-large': 'ccl-78aebf0b4abc45f1',
  'tablet-bottom-large': 'ccl-6e4435eb0fb8dce8',
  'tablet-horizontal-large': 'ccl-58b51533825a4287',
  'tablet-vertical-large': 'ccl-b5146a974c288339',
  'tablet-all-large': 'ccl-6dda4450c8754636',
  'tablet-adjacent-horizontal-large': 'ccl-e1fb9d16c6c5256a',
  'tablet-adjacent-vertical-large': 'ccl-291e9e95cc586ce9',
  'tablet-right-medium': 'ccl-16feb2d24b02249f',
  'tablet-left-medium': 'ccl-ac470402cd1945d4',
  'tablet-top-medium': 'ccl-8898d252f0f38294',
  'tablet-bottom-medium': 'ccl-474531e489ccc6d1',
  'tablet-horizontal-medium': 'ccl-69ea314ade466ed8',
  'tablet-vertical-medium': 'ccl-f6e0aebed193abd7',
  'tablet-all-medium': 'ccl-dd7857f5b58a6a66',
  'tablet-adjacent-horizontal-medium': 'ccl-727d2be3a98ffc2e',
  'tablet-adjacent-vertical-medium': 'ccl-6f1f351e2b42d7e6',
  'tablet-right-small': 'ccl-7d80a52f2333d8d3',
  'tablet-left-small': 'ccl-a99e7f7120ac9626',
  'tablet-top-small': 'ccl-36b10c52e91ecc18',
  'tablet-bottom-small': 'ccl-140f16ae0fbe83e7',
  'tablet-horizontal-small': 'ccl-44230e9ac2f7a0dd',
  'tablet-vertical-small': 'ccl-ae5b3b02bf7e0401',
  'tablet-all-small': 'ccl-91f6c7716015a2ee',
  'tablet-adjacent-horizontal-small': 'ccl-915fb512476d265f',
  'tablet-adjacent-vertical-small': 'ccl-5cb3a38a645e9dde',
  'tablet-right-x-small': 'ccl-f8298d730f23b772',
  'tablet-left-x-small': 'ccl-5be91f41d9399f13',
  'tablet-top-x-small': 'ccl-5a1dd072dcb761f0',
  'tablet-bottom-x-small': 'ccl-055cd9073d7971aa',
  'tablet-horizontal-x-small': 'ccl-1021a44898560be1',
  'tablet-vertical-x-small': 'ccl-3d6f7bd7cee52b11',
  'tablet-all-x-small': 'ccl-955b32756f0abaad',
  'tablet-adjacent-horizontal-x-small': 'ccl-5276291b6da42baa',
  'tablet-adjacent-vertical-x-small': 'ccl-89861f99f2d18228',
  'tablet-right-zero': 'ccl-08a2df08ac68413d',
  'tablet-left-zero': 'ccl-5e4e59d1607ebb08',
  'tablet-top-zero': 'ccl-31fae28d3e0a0669',
  'tablet-bottom-zero': 'ccl-27dc921e7c1494c1',
  'tablet-horizontal-zero': 'ccl-e0fa4486ea16160b',
  'tablet-vertical-zero': 'ccl-16ecdfc3ea781ac4',
  'tablet-all-zero': 'ccl-72c700cf46401067',
  'tablet-adjacent-horizontal-zero': 'ccl-b0c2de4c4b1e4f65',
  'tablet-adjacent-vertical-zero': 'ccl-b6683efcbdab8469',
  'desktop-right-x-large': 'ccl-d5d5441353291218',
  'desktop-left-x-large': 'ccl-a1dcef3bb8018a1b',
  'desktop-top-x-large': 'ccl-ce3be2b51c2db8ab',
  'desktop-bottom-x-large': 'ccl-f396d07ab6075431',
  'desktop-horizontal-x-large': 'ccl-cfc0a6e7984a2cfe',
  'desktop-vertical-x-large': 'ccl-d1e4108d838922cc',
  'desktop-all-x-large': 'ccl-f4d6437f83935546',
  'desktop-adjacent-horizontal-x-large': 'ccl-d9b4ead22e13a408',
  'desktop-adjacent-vertical-x-large': 'ccl-29f0028ca8b096e1',
  'desktop-right-large': 'ccl-1f8d6188abe94600',
  'desktop-left-large': 'ccl-043bd6a821d56352',
  'desktop-top-large': 'ccl-5f494078a76159b9',
  'desktop-bottom-large': 'ccl-e23ad9b6db1f3d0f',
  'desktop-horizontal-large': 'ccl-ed65796e03d66a1b',
  'desktop-vertical-large': 'ccl-9fce1a99bb38c39e',
  'desktop-all-large': 'ccl-f28a3638747bbf4d',
  'desktop-adjacent-horizontal-large': 'ccl-b5b394674b3ccd3d',
  'desktop-adjacent-vertical-large': 'ccl-122426d010f42f46',
  'desktop-right-medium': 'ccl-d59c59dd33bc06eb',
  'desktop-left-medium': 'ccl-f66ece2e8c21fc78',
  'desktop-top-medium': 'ccl-61bb170e108909bd',
  'desktop-bottom-medium': 'ccl-43057b5c4b0560c9',
  'desktop-horizontal-medium': 'ccl-d1bd23ffbc3ecf47',
  'desktop-vertical-medium': 'ccl-2d1a5b2727bc5afa',
  'desktop-all-medium': 'ccl-de5b4c6c33bc3f04',
  'desktop-adjacent-horizontal-medium': 'ccl-0930d95e9d01e067',
  'desktop-adjacent-vertical-medium': 'ccl-a8ac5896997352bb',
  'desktop-right-small': 'ccl-bf59c9194b8a48bb',
  'desktop-left-small': 'ccl-f49602ef5e7457ce',
  'desktop-top-small': 'ccl-c69c3157595d6d99',
  'desktop-bottom-small': 'ccl-643c0dbf521d1582',
  'desktop-horizontal-small': 'ccl-511db7c19328cec8',
  'desktop-vertical-small': 'ccl-e09c35605fe2643d',
  'desktop-all-small': 'ccl-20db4870473c80ca',
  'desktop-adjacent-horizontal-small': 'ccl-3af1a12f52780114',
  'desktop-adjacent-vertical-small': 'ccl-9c44018941d6f267',
  'desktop-right-x-small': 'ccl-c735071ddae5670e',
  'desktop-left-x-small': 'ccl-b023a9334afb0629',
  'desktop-top-x-small': 'ccl-e954c1413d3631fc',
  'desktop-bottom-x-small': 'ccl-2c99202e1c846b5e',
  'desktop-horizontal-x-small': 'ccl-7cd154cc5f48986c',
  'desktop-vertical-x-small': 'ccl-55488fe09dc6cd3a',
  'desktop-all-x-small': 'ccl-6ff3d30316b914aa',
  'desktop-adjacent-horizontal-x-small': 'ccl-3b045faa8421ff4d',
  'desktop-adjacent-vertical-x-small': 'ccl-d2726de4db2a23d5',
  'desktop-right-zero': 'ccl-4903bf4f0d0cc732',
  'desktop-left-zero': 'ccl-87bf1ddd9b91d791',
  'desktop-top-zero': 'ccl-46e412319a08bb8f',
  'desktop-bottom-zero': 'ccl-bbda07a4f4bcef62',
  'desktop-horizontal-zero': 'ccl-1b72c705ae2845c2',
  'desktop-vertical-zero': 'ccl-5215d59508533f22',
  'desktop-all-zero': 'ccl-c1068feb12e9e96c',
  'desktop-adjacent-horizontal-zero': 'ccl-9acd1655556619b8',
  'desktop-adjacent-vertical-zero': 'ccl-7084ab84e756621b',
  'placeholder': 'ccl-588624e18f4728e3'
};


var SIZES = ['x-large', 'large', 'medium', 'small', 'x-small'];
var SIZES_OR_ZERO = [].concat(SIZES, [0]);
var BREAKPOINTS = ['mobile', 'tablet', 'desktop'];

function parseSpacingProp(spacings) {
  var spacingsArr = spacings;

  // If you don't provide any spacing at all,
  // it should do nothing.
  if (!spacings || !spacingsArr.length) {
    return {};
  }

  // If it isn't an array we want to convert it to an
  // array for easier handling.
  if (!Array.isArray(spacings)) {
    var trimmedSpacing = spacings.trim();

    // If it's the string shorthand (e.g. "small 0 0 0"):
    if (trimmedSpacing.includes(' ')) {
      spacingsArr = trimmedSpacing.split(' ').filter(Boolean).map(function (size) {
        return size === '0' ? null : size;
      });

      // If it's a single size (e.g. "small")
    } else {
      spacingsArr = [trimmedSpacing];
    }
  }

  // Filter out any values that aren't valid sizes.
  var validSpacingsArr = spacingsArr.map(function (spacingStr) {
    if (SIZES.includes(spacingStr) || spacingStr === null) {
      return spacingStr;
    }
    // eslint-disable-next-line no-console
    console.warn('"' + spacingStr + '" is not a valid size and will be ignored. You can use one of ' + SIZES.map(function (s) {
      return '"' + s + '"';
    }) + ' or 0.'); // eslint-disable-line no-console
    return null;
  });

  if (validSpacingsArr.length > 4) {
    // eslint-disable-next-line no-console
    console.warn('Looks like an invalid spacing argument provided. Expected a string or an array of max 4 items. Provided:'); // eslint-disable-line no-console
    console.warn(spacings); // eslint-disable-line no-console
  }

  switch (validSpacingsArr.slice(0, 4).length) {
    case 1:
      return {
        all: validSpacingsArr[0]
      };
    case 2:
      return {
        vertical: validSpacingsArr[0],
        horizontal: validSpacingsArr[1]
      };
    case 3:
      return {
        top: validSpacingsArr[0],
        horizontal: validSpacingsArr[1],
        bottom: validSpacingsArr[2]
      };
    case 4:
      return {
        top: validSpacingsArr[0],
        right: validSpacingsArr[1],
        bottom: validSpacingsArr[2],
        left: validSpacingsArr[3]
      };
    default:
      return {};
  }
}

var SpacerElement = function (_Component) {
  _inherits(SpacerElement, _Component);

  function SpacerElement() {
    _classCallCheck(this, SpacerElement);

    return _possibleConstructorReturn(this, (SpacerElement.__proto__ || Object.getPrototypeOf(SpacerElement)).apply(this, arguments));
  }

  _createClass(SpacerElement, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
    }
  }, {
    key: 'getPlaceholderChildren',
    value: function getPlaceholderChildren() {
      var _props = this.props,
          placeholderClassName = _props.placeholderClassName,
          children = _props.children,
          element = _props.element;


      var PlaceholderElement = void 0;

      switch (element) {
        case 'p':
          return children;
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
        case 'h5':
          {
            PlaceholderElement = 'div';
            break;
          }
        case 'span':
        default:
          {
            PlaceholderElement = element;
            break;
          }
      }

      return _react2.default.createElement(
        PlaceholderElement,
        { className: (0, _classnames3.default)(styles.placeholder, placeholderClassName) },
        children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props2 = this.props,
          spacing = _props2.spacing,
          adjacentHorizontalSpacing = _props2.adjacentHorizontalSpacing,
          adjacentVerticalSpacing = _props2.adjacentVerticalSpacing,
          isPlaceholder = _props2.isPlaceholder,
          children = _props2.children,
          element = _props2.element,
          className = _props2.className,
          placeholderClassName = _props2.placeholderClassName,
          otherProps = _objectWithoutProperties(_props2, ['spacing', 'adjacentHorizontalSpacing', 'adjacentVerticalSpacing', 'isPlaceholder', 'children', 'element', 'className', 'placeholderClassName']);

      var hasBreakpoints = (typeof spacing === 'undefined' ? 'undefined' : _typeof(spacing)) === 'object' && !Array.isArray(spacing);
      var hasAdjacentHorizontalBreakpoints = (typeof adjacentHorizontalSpacing === 'undefined' ? 'undefined' : _typeof(adjacentHorizontalSpacing)) === 'object';
      var hasAdjacentVerticalBreakpoints = (typeof adjacentVerticalSpacing === 'undefined' ? 'undefined' : _typeof(adjacentVerticalSpacing)) === 'object';
      var spacingClassNames = {};

      BREAKPOINTS.forEach(function (breakpoint) {
        var parsedSpacings = parseSpacingProp(hasBreakpoints ? spacing[breakpoint] : spacing);
        var breakpointAdjacentHorizontalSpacing = hasAdjacentHorizontalBreakpoints ? adjacentHorizontalSpacing[breakpoint] : adjacentHorizontalSpacing;
        var breakpointAdjacentVerticalSpacing = hasAdjacentVerticalBreakpoints ? adjacentVerticalSpacing[breakpoint] : adjacentVerticalSpacing;
        var prefix = breakpoint !== 'mobile' ? breakpoint + '-' : '';

        /**
         * Only output breakpoint-prefixes classnames if that breakpoint’s spacings
         * were explicitly declared. Otherwise we only output the mobile (i.e.
         * unprefixed) classnames.
         */
        if (!hasBreakpoints && breakpoint === 'mobile' || hasBreakpoints && parsedSpacings) {
          var _extends2;

          spacingClassNames = _extends({}, spacingClassNames, (_extends2 = {}, _defineProperty(_extends2, styles[prefix + 'all-' + parsedSpacings.all], parsedSpacings.all), _defineProperty(_extends2, styles[prefix + 'vertical-' + parsedSpacings.vertical], parsedSpacings.vertical), _defineProperty(_extends2, styles[prefix + 'horizontal-' + parsedSpacings.horizontal], parsedSpacings.horizontal), _defineProperty(_extends2, styles[prefix + 'top-' + parsedSpacings.top], parsedSpacings.top), _defineProperty(_extends2, styles[prefix + 'bottom-' + parsedSpacings.bottom], parsedSpacings.bottom), _defineProperty(_extends2, styles[prefix + 'left-' + parsedSpacings.left], parsedSpacings.left), _defineProperty(_extends2, styles[prefix + 'right-' + parsedSpacings.right], parsedSpacings.right), _extends2));
        }

        /**
         * For above the mobile breakpoint, generate classnames for any
         * breakpoint-specific styles for zero sizes.
         */
        if (hasBreakpoints && breakpoint !== 'mobile') {
          var _extends3;

          /**
           * determine if at any breakpoint prior to the current one, has a given
           * direction been given a non-null value; this is so we can
           * conditionally output the `-zero` classname at *this* breakpoint;
           * otherwise it can be safely omitted.
           */
          var hasZeroClass = function hasZeroClass(targetBreakpoint, direction) {
            var responsiveSpacings = {
              mobile: parseSpacingProp(spacing.mobile),
              tablet: parseSpacingProp(spacing.tablet),
              desktop: parseSpacingProp(spacing.desktop)
            };

            return parsedSpacings[direction] === null && BREAKPOINTS.slice(0, BREAKPOINTS.indexOf(targetBreakpoint)).some(function (prevBreakpoint) {
              return responsiveSpacings[prevBreakpoint][direction] !== null;
            });
          };

          spacingClassNames = _extends({}, spacingClassNames, (_extends3 = {}, _defineProperty(_extends3, styles[breakpoint + '-all-zero'], hasZeroClass(breakpoint, 'all')), _defineProperty(_extends3, styles[breakpoint + '-vertical-zero'], hasZeroClass(breakpoint, 'vertical')), _defineProperty(_extends3, styles[breakpoint + '-horizontal-zero'], hasZeroClass(breakpoint, 'horizontal')), _defineProperty(_extends3, styles[breakpoint + '-top-zero'], hasZeroClass(breakpoint, 'top')), _defineProperty(_extends3, styles[breakpoint + '-bottom-zero'], hasZeroClass(breakpoint, 'bottom')), _defineProperty(_extends3, styles[breakpoint + '-left-zero'], hasZeroClass(breakpoint, 'left')), _defineProperty(_extends3, styles[breakpoint + '-right-zero'], hasZeroClass(breakpoint, 'right')), _extends3));
        }

        /**
         * Only add adjacent spacing classnames for breakpoints explicitly declared.
         */
        if (!hasAdjacentHorizontalBreakpoints && breakpoint === 'mobile' || hasAdjacentHorizontalBreakpoints && breakpointAdjacentHorizontalSpacing) {
          spacingClassNames = _extends({}, spacingClassNames, _defineProperty({}, styles[prefix + 'adjacent-horizontal-' + breakpointAdjacentHorizontalSpacing], breakpointAdjacentHorizontalSpacing));
        }

        /**
         * For above the mobile breakpoint, generate classnames for any
         * breakpoint-specific styles for zero sizes on adjacent horizontal
         * spacing.
         */
        if (hasAdjacentHorizontalBreakpoints && breakpoint !== 'mobile') {
          /**
           * determine if at any breakpoint prior to the current one, has an
           * adjacent horizontal spacing prop been given a non-null value; this is
           * so we can conditionally output the `-zero` classname at *this*
           * breakpoint; otherwise it can be safely omitted.
           */
          var _hasZeroClass = function _hasZeroClass(targetBreakpoint) {
            return adjacentHorizontalSpacing[breakpoint] === 0 && BREAKPOINTS.slice(0, BREAKPOINTS.indexOf(targetBreakpoint)).some(function (prevBreakpoint) {
              return adjacentHorizontalSpacing[prevBreakpoint] !== undefined;
            });
          };

          spacingClassNames = _extends({}, spacingClassNames, _defineProperty({}, styles[breakpoint + '-adjacent-horizontal-zero'], _hasZeroClass(breakpoint)));
        }

        /**
         * Only add adjacent spacing classnames for breakpoints explicitly declared.
         */
        if (!hasAdjacentVerticalBreakpoints && breakpoint === 'mobile' || hasAdjacentVerticalBreakpoints && breakpointAdjacentVerticalSpacing) {
          spacingClassNames = _extends({}, spacingClassNames, _defineProperty({}, styles[prefix + 'adjacent-vertical-' + breakpointAdjacentVerticalSpacing], breakpointAdjacentVerticalSpacing));
        }

        /**
         * For above the mobile breakpoint, generate classnames for any
         * breakpoint-specific styles for zero sizes on adjacent vertical
         * spacing.
         */
        if (hasAdjacentVerticalBreakpoints && breakpoint !== 'mobile') {
          /**
           * determine if at any breakpoint prior to the current one, has an
           * adjacent vertical spacing prop been given a non-null value; this is
           * so we can conditionally output the `-zero` classname at *this*
           * breakpoint; otherwise it can be safely omitted.
           */

          var _hasZeroClass2 = function _hasZeroClass2(targetBreakpoint) {
            return adjacentVerticalSpacing[breakpoint] === 0 && BREAKPOINTS.slice(0, BREAKPOINTS.indexOf(targetBreakpoint)).some(function (prevBreakpoint) {
              return adjacentVerticalSpacing[prevBreakpoint] !== undefined;
            });
          };

          spacingClassNames = _extends({}, spacingClassNames, _defineProperty({}, styles[breakpoint + '-adjacent-vertical-zero'], _hasZeroClass2(breakpoint)));
        }
      });

      var Element = element || 'div';
      var wrappedChildren = isPlaceholder ? this.getPlaceholderChildren() : children;

      return _react2.default.createElement(
        Element,
        _extends({
          className: (0, _classnames3.default)(className, spacingClassNames, (_classnames = {}, _defineProperty(_classnames, styles.placeholder, isPlaceholder && element === 'p'), _defineProperty(_classnames, placeholderClassName, isPlaceholder && element === 'p'), _classnames))
        }, otherProps),
        wrappedChildren
      );
    }
  }]);

  return SpacerElement;
}(_react.Component);

SpacerElement.displayName = 'SpacerElement';


SpacerElement.propTypes = {
  /**
   * You can provide spacing clockwise like so: `spacing="small medium 0
   * small"`.
   *
   * Also supports shorthands similiar to css so you can provide just a single
   * size (i.e "small") to have the same spacing on every side. Similiarly if
   * you want matching vertical and horizontal spacing you can do `"large
   * medium"` like in CSS.
   *
   * If you wish, you can can also use an array instead of a string (e.g
   * `['small', null, 'medium']`). This is useful for programatic manipulation
   * of the spacing prop.
   *
   * You can also supply an object with keys corresponding to the named
   * breakpoints (`mobile`, `tablet` and `desktop`) containing either a string
   * shorthand or array syntax value, e.g.
   * `{ mobile: 'small 0', tablet: 'medium 0', desktop: 'large 0 }`
   */
  spacing: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOf(SIZES)), _propTypes2.default.shape({
    mobile: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOf(SIZES))]),
    tablet: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOf(SIZES))]),
    desktop: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOf(SIZES))])
  })]),

  /**
   * Allows spacing to be applied only when this element has an adjacent sibling
   * preceding it, in a horizontal direction (i.e. to the left of the target
   * element). By default applies to all breakpoints, or if supplied an object
   * containing a named breakpoint key, applies to that breakpoint.
   */
  adjacentHorizontalSpacing: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
    mobile: _propTypes2.default.oneOf(SIZES_OR_ZERO),
    tablet: _propTypes2.default.oneOf(SIZES_OR_ZERO),
    desktop: _propTypes2.default.oneOf(SIZES_OR_ZERO)
  })]),

  /**
   * Allows spacing to be applied only when this element has an adjacent sibling
   * preceding it, in a vertical direction (i.e. above the target element).
   * By default applies to all breakpoints, or if supplied an object containing
   * a named breakpoint key, applies to that breakpoint.
   */
  adjacentVerticalSpacing: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
    mobile: _propTypes2.default.oneOf(SIZES_OR_ZERO),
    tablet: _propTypes2.default.oneOf(SIZES_OR_ZERO),
    desktop: _propTypes2.default.oneOf(SIZES_OR_ZERO)
  })]),

  /**
   * Allows this element to act as a placeholder with an animation until the
   * content has loaded.
   */
  isPlaceholder: _propTypes2.default.bool,

  /**
   * To permit a component which uses isPlaceholder to define its own
   * placeholder styles on the spacer element itself, this prop defines another
   * classname which is applied to the underlying SpacerElement only when
   * isPlaceholder is true.
   */
  placeholderClassName: _propTypes2.default.string
};

SpacerElement.defaultProps = {
  spacing: [],
  adjacentHorizontalSpacing: undefined,
  adjacentVerticalSpacing: undefined,
  isPlaceholder: false,
  placeholderClassName: undefined
};

exports.default = SpacerElement;